export default __webpack_public_path__ + "static/lilnadas-cards-health-3-c6768d41867087803d7a9bb499309df2.png";